var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrag2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.1875 5.625a.9375.9375 0 1 0 0-1.875.9375.9375 0 1 0 0 1.875ZM12.8125 5.625a.9375.9375 0 0 0 .9375-.9375.9375.9375 0 0 0-.9375-.9375.9375.9375 0 0 0-.9375.9375c0 .5178.4197.9375.9375.9375ZM7.1875 10.9375A.9375.9375 0 0 0 8.125 10a.9375.9375 0 1 0-1.875 0c0 .5178.4197.9375.9375.9375ZM12.8125 10.9375A.9375.9375 0 0 0 13.75 10a.9375.9375 0 0 0-.9375-.9375.9375.9375 0 0 0-.9375.9375c0 .5178.4197.9375.9375.9375ZM7.1875 16.25a.9375.9375 0 0 0 .9375-.9375.9375.9375 0 0 0-.9375-.9375.9375.9375 0 0 0-.9375.9375c0 .5178.4197.9375.9375.9375ZM12.8125 16.25a.9375.9375 0 0 0 .9375-.9375.9375.9375 0 0 0-.9375-.9375.9375.9375 0 0 0-.9375.9375c0 .5178.4197.9375.9375.9375Z",
    fill: "#37383A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag2);
export default __webpack_public_path__ + "static/media/Drag2.ad6ecd95e4aec25f80dce4275a9f851d.svg";
export { ForwardRef as ReactComponent };